import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONFIGURATION_FIELDS } from '../../../constants/merchant/configuration';
import { ConfigurationFields } from '../ConfigurationFields';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { SectionWrapper } from '../../SectionWrapper';
import { IModalWindow, ModalWindow } from '../../modal/ModalWindow';
import { UpdateComponent } from './withMerchantDetails';
import { RiskLevelSlider } from './RiskLevelSlider';
import { FORM_FIELDS } from '../../../utils/merchantUtils';
import {
	CONFIGURATIONS_FORM_FIELDS,
	CONFIGURATIONS_FORM_FIELDS_NAMES,
} from '../../../constants/merchant/configurations-form';
import { FormInput } from '../FormInput';
import { InputType } from '../../form/form-input-constants';
import { tierMockList } from '../../provider/ProviderDetails';

interface IConfigurationProps {
	isEditMode: boolean;
	setIsEditMode: (value:boolean) => void;
	isLoading: boolean;
	modalState: IModalWindow;
	closeModal: () => void;
	formik: any;
	onEditClick: () => void;
	onCancelClick?: () => void;
}

const MerchantConfiguration = (props: IConfigurationProps): JSX.Element => {
	const { isEditMode, setIsEditMode, isLoading, modalState, closeModal, formik, onEditClick, onCancelClick } = props;

	const { t } = useTranslation();
	const { merchantState: { isMerchantDataLoading, merchantData }} = useMerchants();

	const FIELDS = CONFIGURATION_FIELDS({ t });

	const showPlaceholder = !merchantData || typeof merchantData === 'object' && Object.keys(merchantData).length === 0 || typeof merchantData !== 'object';
	return (
		<>
			<SectionWrapper
				showPlaceholder={showPlaceholder}
				title={t('MERCHANT.CONFIGURATION')}
				sectionAdditionalClass="mb-5 min-height-200"
				isEditMode={isEditMode}
				setIsEditMode={setIsEditMode}
				onEditClick={onEditClick}
				onCancelClick={onCancelClick}
				loading={isLoading}
				pageLoading={isMerchantDataLoading}
				isCardBody
				isEditBlock={!showPlaceholder}
			>
				<div className="row">
					<FormInput
						formik={formik}
						fieldName={CONFIGURATIONS_FORM_FIELDS.RISK_TIER}
						label={t(CONFIGURATIONS_FORM_FIELDS_NAMES.RISK_TIER)}
						placeholder={t(CONFIGURATIONS_FORM_FIELDS_NAMES.RISK_TIER)}
						inputType={InputType.Select}
						data={tierMockList}
						searchable={false}
						isEditMode={isEditMode}
						labelAdditionalClasses="fs-7"
						fakeInputLabelAdditionalClasses="fs-7"
						additionalClasses="risk-tier-width"
						fakeInputAdditionalClass="risk-tier-width"
						isLabelIcon
						tooltipText={t(CONFIGURATIONS_FORM_FIELDS_NAMES.RISK_TIER_DESCRIPTION)}
						key={CONFIGURATIONS_FORM_FIELDS.RISK_TIER}
					/>
					<div>
						<RiskLevelSlider
							formik={formik}
							isEditMode={isEditMode}
							fieldName={FORM_FIELDS.RISK_LEVEL}
							title={t(CONFIGURATIONS_FORM_FIELDS_NAMES.RISK_LEVEL)}
						/>
					</div>
					<div>
						<RiskLevelSlider
							formik={formik}
							isEditMode={isEditMode}
							fieldName={FORM_FIELDS.RISK_LEVEL_VISA}
							title={t(CONFIGURATIONS_FORM_FIELDS_NAMES.RISK_LEVEL_VISA)}
						/>
					</div>
					{
						FIELDS.map((elem, index) => (
							<ConfigurationFields
								key={index}
								formik={formik}
								isEditMode={isEditMode}
								elem={elem}

							/>
						))
					}
				</div>
			</SectionWrapper>
			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
		</>
	);
};

export default UpdateComponent(MerchantConfiguration, 'configurations');
